module.exports = __webpack_public_path__ + "img/logo-sumut.801bef56.png";